import React, { useState, useEffect, useContext } from 'react';
import { Box, Typography, Divider, Grid, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import { fetchImageFromAzureBlobStorage, fetchContentFromAzureBlobStorage } from "../../data/Contentapi.js";
import Constants from '../../utils/Constants';
import { MyContext } from '../../globalContext';
import DOMPurify from 'dompurify';



const Header = () => {
  const [headerLogoSrc, setHeaderLogoSrc] = useState('');
  const [providerSearchImageSrc, setProviderSearchImageSrc] = useState('');
  const [searchDownTimeData, setSearchDownTimeData]= useState('');
  const [emailDownTimeData, setEmailDownTimeData]= useState('');

  const { t } = useTranslation();
  const { languageData } = useContext(MyContext);

  const getHeaderLogo = async () => {
    try {
      const imageData = await fetchImageFromAzureBlobStorage(Constants.MPI_HEADER_LOGO_FILENAME);
      setHeaderLogoSrc(`data:${imageData.contentType};base64,${imageData.imageString}`);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getProviderSearchImage = async () => {
    try {
      const imageData = await fetchImageFromAzureBlobStorage(Constants.PROVIDER_SEARCH_IMAGE_FILENAME);
      setProviderSearchImageSrc(`data:${imageData.contentType};base64,${imageData.imageString}`);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getSearchDownTime = async () => {
    try {
      const content = await fetchContentFromAzureBlobStorage(
          languageData.toLowerCase(),
          "Downtime",
          "PROVIDER_SRCH_DOWNTIME_MSG"          
      );
      setSearchDownTimeData(content.contentData);
  } catch (e) {
      console.log(e.message);
  }
  };

  const getEmailhDownTime = async () => {
    try {
      const content = await fetchContentFromAzureBlobStorage(
          languageData.toLowerCase(),
          "Downtime",
          "PS_EMAIL_DOWNTIME_MSG"        
      );
      setEmailDownTimeData(content.contentData);
  } catch (e) {
      console.log(e.message);
  }
  };


  useEffect(() => {
    setSearchDownTimeData("");
    setEmailDownTimeData("");
    
    getHeaderLogo();
    getProviderSearchImage();
    getSearchDownTime();
    getEmailhDownTime();  
  }, []);

 

  const sanitizedSearchDownTime = DOMPurify.sanitize(searchDownTimeData);
  const sanitizedEmailDownTime = DOMPurify.sanitize(emailDownTimeData);

 

  return (
    <Container sx={{width: "100%", marginY:"2%" }} fixed >
    <Box mx={8} pt={1}>
      <Box id='header-logo-container' my={2}
        sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <img
          src={headerLogoSrc}
          alt="MultiPlan Provider Search"
          className="header-logo"
          // style={{ maxWidth: '100%', height: 'auto' }}
        />
        <LanguageSwitcher />
      </Box>
      <Box>
      <div dangerouslySetInnerHTML={{ __html: sanitizedSearchDownTime }}></div>
      <div dangerouslySetInnerHTML={{ __html: sanitizedEmailDownTime }}></div>
       
      </Box>
      <Divider sx={{ borderBottomWidth: 2 }} />
      <Grid id="header-image-container" container>
        <Grid item xs={12} sm={12} md={12} lg={7} pt={2} pb={2}>
          <Typography variant='h1' align='left' fontWeight='bold' className="header-info-font" id='header-info-1' mb={1}>
            {t('headerInfoText1')}
          </Typography>
          <Divider sx={{ borderWidth: 4, maxWidth: '46px', borderColor: '#007839' }} />
          <Typography align='left' mt={1} sx={{fontSize:"16pt"}}>{t('welcomeText')} </Typography>
        </Grid>
        <Grid item xs={12} md={12} lg={5} id='header-provider-image'>
          <img
            src={providerSearchImageSrc}
            alt="Two physicians walk up a flight of stairs while having a discussion"
            style={{ width: '100%', height: "100%" }}
          />
        </Grid>
      </Grid>
      <Divider sx={{ borderBottomWidth: 2 }} />
    </Box>
    </Container>
  )
}
export default Header
